import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toggleMobileNav } from '../../../actions/navigationActions';
import * as StyledMobileNav from './mobileNavigation.styles';
import { MobileHamburger } from '../../header/header.styles';
import MobileNavItem from './mobileNavItem';

export const traverse = (items, level, history) => items.map(item => !item.Hidden && (
	<MobileNavItem
		key={item.Id}
		item={item}
		level={level}
		history={history} />
));

const MobileNavigation = ({
	navigationReducer,
	dispatch,
	history
}) => {
	const { mobileNavOpen } = navigationReducer;

	const onBurgerClick = () => {
		dispatch(toggleMobileNav(!mobileNavOpen));
	};

	return (
		<StyledMobileNav.Nav open={navigationReducer.mobileNavOpen}>
			<StyledMobileNav.CloseNavWrapper onClick={onBurgerClick}>
				<MobileHamburger
					open={mobileNavOpen}
				/>
			</StyledMobileNav.CloseNavWrapper>
			{
				// TODO: Perhaps something a bit more elegant than navigation[0]
				navigationReducer.navigation !== null && traverse(navigationReducer.navigation[0].Children, 1, history)
			}
		</StyledMobileNav.Nav>
	);
};

const mapStateToProps = ({ navigationReducer }) => ({
	navigationReducer
});

export default withRouter(connect(mapStateToProps)(MobileNavigation));
